<template>

	<div>

		<h1>KENI! Some inline style on the select</h1>

		<!--Display-->
		<section>
			<div v-if="!loading && !editing">
				<table class="table">
					<thead>
					<tr>
						<th>Ticket</th>
						<th>Sold</th>
						<th>Allocated</th>
						<th>Lost spaces</th>
						<th>Sales moved</th>
						<th>Sales received</th>
						<th>Available Spaces</th>
						<th v-if="!editing">Actions</th>
					</tr>
					</thead>
					<tbody>
					<tr v-for="ticket in event.tickets">
						<td>{{ticket.ticket_data.lang.en_GB.title}}</td>
						<td>{{ticket.sale_contents.length}}</td>
						<td>{{ticket.allocated}}</td>
						<td>{{getWastageSpaces(ticket)}}</td>
						<td>{{getWastageMoved(ticket)}}</td>
						<td>{{getWastageReceived(ticket)}}</td>
						<td>
							{{getAvailableSpaces(ticket)}}
							<small class="text-danger" v-if="ticket.season_moved_sales">Sales were transfer only for this event</small>
						</td>
						<td v-if="!editing">
							<div v-if="ticketHasWastageActive(ticket)">
								<a	v-on:click="finishWastage(ticket)"
									  href="#"
									  class="btn btn-danger">Finish Wastage</a>
							</div>
							<div v-else>
								<a	v-on:click="addWastage(ticket)"
									  href="#"
									  class="btn btn-primary">Add Wastage</a>
							</div>
						</td>
					</tr>
					</tbody>
				</table>
			</div>
		</section>


		<!--Wastage-->
		<section>
			<div v-if="editing">
				<div class="card">
					<div class="card-body">
						<div>
							<h4>Applying wastage - {{current_ticket.ticket_data.lang.en_GB.title}}</h4>
						</div>
						<div class="container ">

							<div v-if="!current_wastage.applied">

								<!--Information about the current wastage / current ticket-->
								<section>
									<div class="row">
										<div class="col">
											<span>Allocated (with no wastage):</span>
											<strong>{{current_ticket.allocated}}</strong>
										</div>
										<div class="col">
											<span>Allocated (after wastage):</span>
											<!--@todo need's to account with previous wastage if more than one-->
											<strong>{{current_ticket.allocated - current_wastage.amount}}</strong>
										</div>
										<div class="col">
											<span>Remaining spaces:</span>
											<strong>{{remaining}}</strong>
										</div>
									</div>
								</section>

								<!--Amount and notes-->
								<section>
									<div class="row mt-5">
										<div class="col">
											<form>
												<strong>Amount of spaces wasted</strong>
												<input
														type="number"
														class="border-0"
														:min="current_wastage.min"
														:max="current_ticket.allocated"
														step="1"
														v-model="current_wastage.amount"
														@change="current_wastage.amount > current_ticket.allocated ? current_wastage.amount = current_ticket.allocated : null" />
												<div class="md-form range-field">
													<input
															v-model="current_wastage.amount"
															type="range"
															:min="current_wastage.min"
															:max="current_ticket.allocated" />
												</div>
											</form>
										</div>
										<div class="col">
											<div class="md-form">
												<textarea v-model="current_wastage.notes" id="textarea-char-counter" class="md-textarea" length="512"></textarea>
												<label for="textarea-char-counter">Wastage notes:</label>
											</div>
										</div>
									</div>
								</section>

								<!--Date and time of Expire-->
								<section>
									<div class="row">
										<div class="col-12">
											<h5>Expiration date for all future created tickets</h5>
										</div>
									</div>
									<div class="row">
										<div class="col-4">
											<div class="form-group">
												<input v-model="current_wastage.expire_date" class="border-0" type="checkbox"
													   id="enabled--expire-date" checked />
												<label for="enabled--expire-date">Enable expire date</label>
											</div>
										</div>
										<div v-if="current_wastage.expire_date" class="col-4">
											<input v-model="current_wastage.time" type="time"  class="border-0"/>
										</div>
										<div v-if="current_wastage.expire_date" class="col-4">
											<input v-model="current_wastage.date" type="date"/>
										</div>
									</div>
								</section>

								<!--Wastage Reason-->
								<section>
									<div class="row">
										<div class="col">
											<label for="select_wastage_reason">Select a wastage reason</label>
										</div>
										<div class="col">
											<select v-model="current_wastage.wastage_reason_id" id="select_wastage_reason" name="wastage_reason_id" style="display: block !important;">
												<option
														v-for="wastage_reason in wastage_reasons"
														:value="wastage_reason.id">{{wastage_reason.lang.en_GB.title}}</option>
											</select>
										</div>
										<div class="col">
											<p>{{getWastageReasonDetails(current_wastage.wastage_reason_id)}}</p>
										</div>
									</div>
								</section>

									<!--Moving sales-->
								<!--If we need to move sales this is the thing!-->
								<section>
									<div class="row mt-5" v-if="remaining < 0">
										<div class="col">
											<div class="container">

												<div class="row">
													<div class="col text-center">
														<strong class="text-danger">We need to move
															{{-remaining}} sale(s)</strong>
														<strong>: {{getRemainingWithEntitiesAmount()}} remaining</strong>
													</div>
												</div>

												<div class="alert alert-success">
													<span>We are going to move sales with order:</span>
													<ul>
														<li>Latest sales not refunded</li>
														<li>Latest sales refunded</li>
													</ul>

												</div>

												<div class="row">
													<table class="table">
														<thead>
														<tr>
															<th>Ticket</th>
															<th>Sold</th>
															<th>Allocated</th>
															<th>Available Spaces</th>
															<th>Move Spaces</th>
														</tr>
														</thead>
														<tbody>
														<tr v-for="ticket in possible_tickets">
															<td>{{ticket.ticket_data.lang.en_GB.title}}</td>
															<td>{{ticket.sales}}</td>
															<td>{{ticket.allocated}}</td>
															<td>{{getAvailableSpaces(ticket)}}</td>
															<td>
																<input
																		type="number"
																		:min="0"
																		:max="getMaxTransferForTicket(ticket)"
																		step="1"
																		v-model="ticket.transfer"
																		@change="
																	ticket.transfer > getMaxTransferForTicket(ticket) ?
																	ticket.transfer = getMaxTransferForTicket(ticket) :
																	null;" />
															</td>

														</tr>
														</tbody>
													</table>
												</div>

											</div>
										</div>
									</div>
								</section>
							</div>


							<!--Wastage is applied / Apply wastage-->
							<section>
								<div v-if="current_wastage.applied">
									<div class="row">
										<div class="col-12">
											<h5><b>Wastage of {{current_wastage.amount}} spaces applied</b></h5>
										</div>
									</div>

									<div v-if="current_wastage.moved.length > 0" class="row">
										<div class="col-12">
											<table class="table">
												<thead>
												<tr>
													<th>First Name</th>
													<th>Last Name</th>
													<th>Email</th>
													<th>Telephone</th>
													<th>Sale Reference</th>
													<th>Transferred to new ticket</th>
												</tr>
												</thead>
												<tbody>
												<tr v-for="sale in current_wastage.moved">
													<td>{{sale.first_name}}</td>
													<td>{{sale.last_name}}</td>
													<td>{{sale.email}}</td>
													<td>{{sale.telephone}}</td>
													<td>{{sale.reference}}</td>
													<td>{{sale.ticket_name}}</td>
												</tr>
												</tbody>
											</table>


											<button
													v-on:click="exportList()"
													class="btn btn-large btn-primary">Export List</button>
											<button
													v-on:click="sendEmails()"
													class="btn btn-large btn-primary">Send Emails to all users</button>
										</div>
									</div>


									<div class="row">
										<div class="col-12">
											<button
													v-on:click="close()"
													class="btn btn-large btn-primary">Done</button>
										</div>
									</div>
								</div>

								<!--Show buttons to submit or cancel wastage-->
								<div v-else class="row">
									<div class="col-12">
										<button
												v-on:click="cancel_wastage()"
												class="btn btn-large btn-primary">Cancel wastage</button>
										<button
												v-on:click="submit_wastage()"
												class="btn btn-large btn-primary">Apply wastage</button>
									</div>
								</div>
							</section>

						</div>

					</div>
				</div>
			</div>
		</section>


	</div>

</template>

<style>

</style>

<script>
    // add imports here
    import {_} from 'underscore';

    export default {
        props: ['content'],
        mounted() {
        	this.read_url = this.content.read_url;
        	this.create_url = this.content.create_url;
        	this.update_url = this.content.update_url;
        	this.export_url = this.content.export_url;
        	this.close_url = this.content.close_url;
        	this.send_emails_url = this.content.send_emails_url;
        	this.grabData();
        },
        data() {
        	return {
				read_url: '',
				create_url: '',
				update_url: '',
				export_url: '',
				close_url: '',
				send_emails_url: '',


				event: {},
				wastage_reasons: [],

				loading: true,
				editing: false,
				current_ticket: null,
				total_possible_spaces_to_move: 0,
				possible_tickets: [],
				current_wastage: {
					amount: 0,
					min: 0,
					notes: "",
					remaining: 0,
					new_entry: true,
					applied: false,
					moving_id: null,
					assigned: 0,
					wastage_reason_id: 0,

					expire_date: true,

					time: '',
					date: '',

					moved: []
				}
            }
        },
        methods: {
        	grabData(){
        		let _this = this;

        		_this.loading = true;
        		axios.get(this.read_url)
					.then(function (response){
						if (response.data.success){
							console.log(response.data.event);
							_this.event = response.data.event;
							_this.wastage_reasons = response.data.wastage_reasons;

							console.log(_this.wastage_reasons);

							_this.loading = false;
						}
					});
			},

			addWastage(ticket){
        		if (!this.editing){
        			this.editing = true;
        			this.current_ticket = $.extend(true, {}, ticket);
        			this.current_wastage.amount = 0;
        			this.current_wastage.min = 0;
        			this.current_wastage.notes = "";
        			this.current_wastage.new_entry = true;
        			this.current_wastage.assigned = 0;
        			this.current_wastage.remaining = 0;
					this.current_wastage.wastage_reason_id = 0;
					this.current_wastage.expire_date = true;
					this.current_wastage.time = '';
					this.current_wastage.date = '';
				}
			},


			create_wastage(ticket){
				let _this = this;

				axios.post(_this.create_url, {
					notes: _this.current_wastage.notes,
					spaces: _this.current_wastage.amount,
					ticket_id: _this.current_ticket.id,
					transfer_to_tickets: _this.possible_tickets,
					wastage_reason_id: _this.current_wastage.wastage_reason_id,
					date: _this.current_wastage.date,
					time: _this.current_wastage.time,
					expire_date: _this.current_wastage.expire_date
				})
					.then(function (response){
						if (response.data.success){
							response.data.selected.forEach(function (moved){
								let data = {
									first_name: moved.sale.user.first_name,
									last_name: moved.sale.user.last_name,
									email: moved.sale.user.email,
									telephone: moved.sale.user.telephone,
									reference: moved.sale.reference,
									ticket_name: moved.ticket_transfer.ticket_data.lang.en_GB.title
								};

								_this.current_wastage.moved.push(data);
							});

							_this.current_wastage.applied = true;
							_this.current_wastage.wastage_id = response.data.wastage.id;
						}
						else {
							//Something went wrong :(
							toastr.error(response.data.message);
						}
					});
			},

			cancel_wastage(){
        		this.editing = false;
        		this.current_ticket = {};
        		this.possible_tickets = [];
			},

			getPossibleEntitiesToMove(){
				if (this.remaining < 0){
					this.possible_tickets = [];
					this.total_possible_spaces_to_move = 0;

					if (this.event.tickets.length < 2){
						toastr.error('We need another ticket to move sales');
						return;
					}

					//now we need to check free spaces for all tickets assign
					for (let i=0; i<this.event.tickets.length; i++){

						if (this.event.tickets[i].id !== this.current_ticket.id &&
							this.event.tickets[i].ticket_type === 'single' &&
							this.getAvailableSpaces(this.event.tickets[i]) >= -this.remaining){

							this.total_possible_spaces_to_move += this.getAvailableSpaces(this.event.tickets[i]);
							this.possible_tickets.push({
								id: this.event.tickets[i].id,
								ticket_type: this.event.tickets[i].ticket_type,
								allocated: this.event.tickets[i].allocated,
								entity_id: this.event.tickets[i].entity_id,
								ticket_data: this.event.tickets[i].ticket_data,
								sales: this.event.tickets[i].sale_contents.length,
								sale_contents: this.event.tickets[i].sale_contents,
								wastage: this.event.tickets[i].wastage,
								received_wastage_transfers: this.event.tickets[i].received_wastage_transfers,
								transfer: 0
							});
						}
					}

					if (this.total_possible_spaces_to_move <= 0){
						//we don't have a ticket that can take the sales
						toastr.error('We need another ticket with more than ' + -this.remaining + ' spaces available');
						return;
					}
				}
			},

			exportList(){
        		//Asks to export the list to the server
        		window.open(this.export_url + '?wastage_id=' + this.current_wastage.wastage_id,'_blank');
			},

			sendEmails(){
        		console.log('Not finished');
        		let _this = this;

        		axios.post(_this.send_emails_url, {
        			wastage_id: _this.current_wastage.wastage_id
				})
					.then(function (response){

					});
			},



			finishWastage(ticket){
        		let
					selected_wastage = this.getActiveWastage(ticket),
					_this = this;

        		if (selected_wastage == null){
        			//Something went wrong :/
					toastr.error('Impossible to finish wastage');
				}

				else{
        			if (confirm('Are you sure you want to finish this wastage?')){

						axios.post(_this.update_url, {
							wastage_id: selected_wastage.id,
							expire: true
						})
							.then(function (response){
								window.location.reload();
							});
					}
				}
			},

			close(){
        		window.location = this.close_url;
			},

			submit_wastage(){
				//@todo validate stuff

				//we can create straight away
				if (this.getRemainingWithEntitiesAmount() > 0){
					toastr.error('We still need to move some tickets');
				}
				else if (this.current_wastage.wastage_reason_id < 1){
					toastr.error('Select a reason of wastage');
				}
				else {
					this.create_wastage(this.current_ticket);
				}
			},

			getMaxTransferForTicket(ticket){
        		let total = this.getRemainingWithEntitiesAmount();

        		// console.log(total, ticket.allocated - ticket.sales, this.getAvailableSpaces(this.current_ticket), this.current_wastage.amount);
				total += parseInt(ticket.transfer);

        		if (total > ticket.allocated - ticket.sales){
					return ticket.allocated - ticket.sales - total;
				}
				else {
        			return total;
				}
			},

			getRemainingWithEntitiesAmount(){
				let total = 0;

				for (let i=0; i<this.possible_tickets.length; i++){
					total += parseInt(this.possible_tickets[i].transfer);
				}

				return -this.remaining - total;
			},


			getWastageReasonDetails(id){
        		for (let i=0; i<this.wastage_reasons.length; i++){
        			if (this.wastage_reasons[i].id === id)
        				return this.wastage_reasons[i].lang.en_GB.description;
				}
			},


			getActiveWastage(ticket){
				let selected_wastage = null;

				ticket.wastage.forEach(function (wastage){
					if (wastage.date_expired != null){
						let date = new Date(Date.parse(wastage.date_expired)),
							now = new Date();

						if (date > now){
							//if it was not expired this must be the one, remember it might have more than one wastage applied
							selected_wastage = wastage;
						}
					}
					else {
						selected_wastage = wastage;
					}
				});

				return selected_wastage;
			},

			getAvailableSpaces(ticket, escape_multi_events_rule = false){
        		//@todo Not accounting with recieved wastage if other wastage is applied
				// remove the if just here and replace with the math and only return 1 variable

				let
					sales_received = 0,
					sales_transferred = 0,
					active_wastage_spaces = 0,
					sales = ticket.sale_contents.length,
					allocated = ticket.allocated;



				if (ticket.wastage.length > 0){
					let now = new Date();

					for (let i = 0; i < ticket.wastage.length; i++){
						if (ticket.wastage[i].date_expired !== null){
							let date = new Date(Date.parse(ticket.wastage[i].date_expired));

							if (now > date){
								//Already expired, we need to take in account of the sales transferred if ticket type is single that is
								if (ticket.ticket_type === 'single' || escape_multi_events_rule){
									sales_transferred += ticket.wastage[i].wastage_transfers.length;
								}
								else {
									//This indicates that the sales were moved, but only for this event, so no changes unless override
									ticket.season_moved_sales = true;
								}
							}
							else {
								//We need to remove from allocation, wastage space
								active_wastage_spaces += ticket.wastage[i].spaces;
								sales_transferred += ticket.wastage[i].wastage_transfers.length;
							}
						}
						else {
							//We need to remove from allocation, wastage space
							active_wastage_spaces += ticket.wastage[i].spaces;
							sales_transferred += ticket.wastage[i].wastage_transfers.length;
						}
					}
				}

				//Did this ticket received any sales form other wastage?
				if (ticket.received_wastage_transfers.length > 0){
					sales_received = ticket.received_wastage_transfers.length;
				}

				//Ok, now we have all data to calculate the available spaces
				//Allocated - Space lost by current wastage if, - sales - sales received + all sales transfered to other tickets
				return allocated - active_wastage_spaces - sales - sales_received + sales_transferred;
			},


			getWastageSpaces(ticket){
        		let active_wastage = this.getActiveWastage(ticket);

        		if (active_wastage !== null){
        			return active_wastage.spaces;
				}
				else {
        			return '-';
				}
			},

			getWastageMoved(ticket){
        		let transfered = 0;

        		ticket.wastage.forEach(function (wastage){
        			transfered += wastage.wastage_transfers.length;
				});

				if (transfered){
					return transfered;
				}
				else {
					return '-';
				}
			},

			getWastageReceived(ticket){
        		if (ticket.received_wastage_transfers.length > 0){
					//We have sales moved to this ticket
					return ticket.received_wastage_transfers.length;
				}
				else {
        			return '-';
				}
			},


			ticketHasWastageActive(ticket){
				if (this.getActiveWastage(ticket) === null){
					return false;
				}
				else {
					return true;
				}
			}
        },
		watch: {
        	'current_wastage.amount': function(){
				this.getPossibleEntitiesToMove();
			}
		},
		computed: {
        	remaining(){
        		//This will return the remaining spaces that we need to move escaping the multi event tickets rule
        		return this.getAvailableSpaces(this.current_ticket, true) - this.current_wastage.amount;
			}
		}
    }
</script>


<style>

</style>



// WEBPACK FOOTER //
// resources/assets/js/components/pages/wastage/WastagePage.vue?54f984fc